import { render, staticRenderFns } from "./CorpEventsLog.vue?vue&type=template&id=2775bc14&scoped=true"
import script from "./CorpEventsLog.vue?vue&type=script&lang=ts"
export * from "./CorpEventsLog.vue?vue&type=script&lang=ts"
import style0 from "./CorpEventsLog.vue?vue&type=style&index=0&id=2775bc14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2775bc14",
  null
  
)

export default component.exports